// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] + "." + {"265":"fbd67238","297":"5a5a6562","643":"87a97c65"}[chunkId] + ".chunk.js";
};